import { isNil } from 'lodash'

const versionSelectors = {
    default: state => state.assignment.versions.find(version => version.is_default),
    isLatestById: id => state =>
        isNil(id)
            ? state.assignment.versions[0] === versionSelectors.default(state)
            : state.assignment.versions[0]?.id === id,
    isPublishedById: id => state =>
        isNil(id)
            ? versionSelectors.default(state)?.is_published
            : state.assignment.versions.find(version => version.id === id)?.is_published,
    currentHasMbas: state => state.assignment.assignment?.current_version?.has_mba,
    currentIsPublished: state => state.assignment.assignment?.current_version?.is_published,
}

export default versionSelectors
